import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { GenericApi } from "./generic.api";
import { IClientDocument } from "../model/client-document.model";
import { createUrl } from "./api.util";

export interface IApiResponse<T> {
  status: boolean;
  message: string;
  data: T;
}

@Injectable()
export class ClientDocumentApi extends GenericApi<IClientDocument> {
  public path = "client-document";

  constructor(public httpClient: HttpClient) {
    super(httpClient);
  }

  public clientDocumentListing(payload: {
    clientId: string;
    search?: string;
    tag?: string;
  }): Observable<IApiResponse<IClientDocument[]>> {
    return this.httpClient.post<IApiResponse<IClientDocument[]>>(
      createUrl(this.path, "list"),
      payload
    );
  }

  public upload(formData: FormData): Observable<IApiResponse<IClientDocument>> {
    return this.httpClient.post<IApiResponse<IClientDocument>>(
      createUrl(this.path),
      formData
    );
  }

  public getDownloadUrl(id: string): Observable<IApiResponse<{ url: string }>> {
    return this.httpClient.get<IApiResponse<{ url: string }>>(
      createUrl(this.path, id, "url")
    );
  }

  public deleteDocument(id: string): Observable<any> {
    return this.httpClient.delete(
      createUrl(this.path, id)
    );
  }
}
